module.exports = __webpack_public_path__ + "static/media/3gpp-icon.2760bdcc.svg";